import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";

import { SITENAMEALIAS, ASSETS, COUNTRYLIST } from "../utils/init";
import {
  showToast,
  showHttpError,
  handleCurrencyDetiails,
  handleDynamicCurrencyDetiails,
  showConfirm,
  formatAmount,
  _isOnlyNumber,
  handleNetworkDetails,
  initialiseNetwork,
  getCurrencyWiseTxnCharge,
} from "../utils/library";
import { Link, withRouter, matchPath } from "react-router-dom";
import {
  addNewEmailBill,
  GetEmailBill,
  UpdateEmailBill,
  DeleteEmailBill,
  SendEmailBill,
  GetMerchantSettings,
  GetMarketPrice,
  FetchUsdBtcLedgerAmount,
} from "../utils/service";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const styles = {
  pageWrapper: { padding: "36px 24px 60px" },
  backRow: { display: "flex", alignItems: "center", gap: "14px", marginBottom: "28px" },
  backBtn: {
    width: "38px", height: "38px", borderRadius: "10px",
    border: "1px solid var(--body-color-less2)", background: "var(--body-color-less)",
    display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer", color: "var(--text-color)", fontSize: "15px",
  },
  pageTitle: { fontSize: "24px", fontWeight: "700", color: "var(--text-color)", margin: 0 },
  pageSubtitle: { fontSize: "13px", opacity: 0.5, margin: "4px 0 0" },
  card: {
    background: "var(--body-color-less)", borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)", marginBottom: "24px",
  },
  cardHeader: {
    display: "flex", alignItems: "center", gap: "12px",
    padding: "20px 28px", borderBottom: "1px solid var(--body-color-less2)",
  },
  cardHeaderIcon: {
    width: "36px", height: "36px", borderRadius: "10px",
    display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px",
  },
  cardHeaderTitle: { fontSize: "16px", fontWeight: "700", color: "var(--text-color)", margin: 0 },
  cardBody: { padding: "24px 28px" },
  formGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" },
  formGroup: { display: "flex", flexDirection: "column", gap: "6px" },
  label: {
    fontSize: "12px", fontWeight: "600", textTransform: "uppercase",
    letterSpacing: "0.3px", color: "var(--text-color)", opacity: 0.7,
  },
  input: {
    padding: "10px 14px", fontSize: "14px", borderRadius: "10px",
    border: "1px solid var(--body-color-less2)", background: "var(--body-color)",
    color: "var(--text-color)", outline: "none", width: "100%", boxSizing: "border-box",
  },
  select: {
    padding: "10px 14px", fontSize: "14px", borderRadius: "10px",
    border: "1px solid var(--body-color-less2)", background: "var(--body-color)",
    color: "var(--text-color)", outline: "none", width: "100%",
    boxSizing: "border-box", appearance: "auto",
  },
  errorText: { fontSize: "11px", color: "#ef4444", marginTop: "2px" },
  checkboxRow: {
    display: "flex", alignItems: "center", gap: "8px",
    gridColumn: "1 / -1", padding: "4px 0",
  },
  checkbox: { width: "16px", height: "16px", accentColor: "var(--btn-color)", cursor: "pointer" },
  checkboxLabel: { fontSize: "13px", fontWeight: "500", color: "var(--text-color)", cursor: "pointer" },
  th: {
    padding: "12px 14px", fontSize: "11px", fontWeight: "700",
    textTransform: "uppercase", letterSpacing: "0.5px", color: "var(--text-color)",
    opacity: 0.5, borderBottom: "1px solid var(--body-color-less2)",
    textAlign: "left", background: "transparent",
  },
  td: {
    padding: "10px 14px", fontSize: "14px", color: "var(--text-color)",
    borderBottom: "1px solid var(--body-color-less2)", verticalAlign: "middle",
  },
  tableInput: {
    padding: "8px 12px", fontSize: "13px", borderRadius: "8px",
    border: "1px solid var(--body-color-less2)", background: "var(--body-color)",
    color: "var(--text-color)", outline: "none", width: "100%", boxSizing: "border-box",
  },
  addItemBtn: {
    padding: "8px 20px", background: "transparent",
    border: "1px dashed var(--body-color-less2)", borderRadius: "10px",
    color: "var(--btn-color)", fontSize: "13px", fontWeight: "600", cursor: "pointer",
    display: "flex", alignItems: "center", gap: "6px", marginBottom: "16px",
  },
  deleteRowBtn: {
    width: "32px", height: "32px", borderRadius: "8px", border: "none",
    background: "rgba(239,68,68,0.1)", color: "#ef4444", fontSize: "14px",
    cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
  },
  totalRow: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "16px 28px", background: "var(--body-color)",
    borderRadius: "0 0 16px 16px", borderTop: "2px solid var(--body-color-less2)",
  },
  totalLabel: { fontSize: "14px", fontWeight: "700", color: "var(--text-color)" },
  totalAmount: {
    fontSize: "16px", fontWeight: "700", color: "var(--btn-color)",
    fontFamily: "'SF Mono', 'Fira Code', monospace",
  },
  infoTip: { position: "relative", display: "inline-flex", alignItems: "center", marginLeft: "6px", cursor: "help" },
  btnPrimary: {
    padding: "10px 28px", background: "var(--btn-color)", color: "#fff",
    border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600",
    cursor: "pointer", letterSpacing: "0.3px", display: "inline-flex", alignItems: "center", gap: "6px",
  },
  btnPrimaryDisabled: {
    padding: "10px 28px", background: "var(--btn-color)", color: "#fff",
    border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600",
    cursor: "not-allowed", opacity: 0.5, letterSpacing: "0.3px",
    display: "inline-flex", alignItems: "center", gap: "6px",
  },
  btnDanger: {
    padding: "10px 24px", background: "rgba(239,68,68,0.1)", color: "#ef4444",
    border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600",
    cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "6px",
  },
  btnSend: {
    padding: "10px 24px", background: "rgba(16,185,129,0.1)", color: "#10b981",
    border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600",
    cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "6px",
  },
  statusBadge: (status) => {
    const map = {
      "27": { bg: "rgba(245,158,11,0.1)", color: "#f59e0b", text: "Draft" },
      "28": { bg: "rgba(59,130,246,0.1)", color: "#3b82f6", text: "Sent" },
      "29": { bg: "rgba(16,185,129,0.1)", color: "#10b981", text: "Paid" },
    };
    const info = map[status] || { bg: "rgba(239,68,68,0.1)", color: "#ef4444", text: "Overpaid" };
    return { padding: "5px 14px", borderRadius: "20px", fontSize: "12px", fontWeight: "600", background: info.bg, color: info.color, display: "inline-block" };
  },
  statusText: (status) => {
    const map = { "27": "Draft", "28": "Sent", "29": "Paid" };
    return map[status] || "Overpaid";
  },
};

class EditEmailbilling extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      marketPriceOnRender: "0.00",
      showLoader: false,
      totalAmount: "0.00",
      action: "add",
      items: [],
      checked: false,
      isRecurringBillChecked: false,
      selectedAsset: {},
      statusMessage: "",
      status: "",
      selectedDate: new Date(),
      formatedDate: "",
      emailAddr: false,
      verifyBtn: false,
      custName: false,
      addr1: false,
      addr2: false,
      city: false,
      stateName: false,
      zipcode: false,
      billNumber: false,
      itemName: false,
      priceNum: false,
      quantityNum: false,
      assets: [],
      statename: "",
      cityName: "",
      countryName: "",
      customerName: "",
      email: "",
      zip: "",
      dateVal: "",
      billnumber: "",
      addr_1: "",
      addr_2: "",
      networkArray: [],
      network: "",
      // ── Processing Fee ──
      processingFeeHandling: "customer",
      // ── txn charge for selected currency ──
      txnCharge: null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.emailRef = React.createRef();
    this.firstNameRef = React.createRef();
    this.address1Ref = React.createRef();
    this.address2Ref = React.createRef();
    this.cityRef = React.createRef();
    this.stateRef = React.createRef();
    this.countryRef = React.createRef();
    this.zipRef = React.createRef();
    this.dateRef = React.createRef();
    this.billNumberRef = React.createRef();
    this.amountRef = React.createRef();
  }

  handleChange = () => {
    this.setState({ checked: !this.state.checked });
  };

  handleRecurringBillChange = () => {
    this.setState({ isRecurringBillChecked: !this.state.isRecurringBillChecked });
  };

  // ── Fetch txn charge for the given asset code and store in state ──
  fetchTxnCharge = async (assetCode) => {
    const charge = await getCurrencyWiseTxnCharge(assetCode);
    this.setState({ txnCharge: charge });
  };

  calculateTotalAmount = () => {
    let row = this.state.items;
    let total = 0;
    for (let i = 0; i < row.length; i++) {
      if (row[i].qty != "" && row[i].price != "") {
        total = total + parseFloat(row[i].qty) * parseFloat(row[i].price);
      }
    }
    this.setState({ totalAmount: formatAmount(total, 5) });
  };

  handleDateChange = (date) => {
    date = new Date(date);
    let year = date.getFullYear();
    let month = parseInt(date.getMonth()) + 1;
    if (parseInt(month) < 10) month = "0" + month;
    let day = date.getDate();
    if (parseInt(day) < 10) day = "0" + day;
    let formatedDate = year + "-" + month + "-" + day;
    console.log("Selected Date ", formatedDate);
    this.setState({ dateVal: date, formatedDate: formatedDate });
  };

  renderEmailBillData = async (id) => {
    let payload = {
      bill_id: id,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    GetEmailBill(payload)
      .then(
        async function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            console.log("due date: ", response.due_date);
            this.setState({
              email: response.email,
              customerName: response.name,
              billnumber: response.bill_number,
            });
            this.handleDateChange(response.due_date);
            if (
              response.state != "" && response.city != "" &&
              response.country != "" && response.address_l_1 != "" &&
              response.address_l_2 != "" && response.zip != ""
            ) {
              this.setState({
                checked: true,
                statename: response.state,
                cityName: response.city,
                countryName: response.country,
                addr_1: response.address_line_1,
                addr_2: response.address_line_2,
              });
              this.zipRef.current.value = response.zip;
            } else {
              this.setState({ checked: false });
            }
            if (response.recurring_bill == "0") {
              this.setState({ isRecurringBillChecked: false });
            } else {
              this.setState({ isRecurringBillChecked: true });
            }
            // ── Restore processing fee selection from API ──
            this.setState({
              processingFeeHandling: parseInt(response.is_processing_fee_applied) === 1 ? "customer" : "merchant",
            });
            const restoredAsset = handleDynamicCurrencyDetiails(this.state.assets, response.currency_id);
            this.setState(
              {
                selectedAsset: restoredAsset,
                networkArray: restoredAsset.network,
                network: restoredAsset.network[0],
                statusMessage: response.status_message,
                status: response.status,
              },
              () => {
                // ── Fetch txn charge for the restored currency ──
                this.fetchTxnCharge(restoredAsset.assetCode);
              }
            );
            let items = JSON.parse(response.items);
            let arr = [];
            for (let i = 0; i < items.length; i++) {
              let obj = {
                row: i + 1,
                item: items[i].item_name,
                qty: formatAmount(items[i].item_quantity, 5),
                price: formatAmount(items[i].item_price, 5),
                fiat_price: formatAmount(items[i].fiat_price, 2),
              };
              arr.push(obj);
            }
            this.setState({ items: arr }, () => { this.calculateTotalAmount(); });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log(err);
          showHttpError(err);
        }.bind(this)
      );
  };

  handleSendEmailBill = () => {
    let payload = {
      bill_id: this.state.billId,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    SendEmailBill(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            this.renderEmailBillData(this.state.billId);
            showToast("success", "Bill send successfully");
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log(err);
          showHttpError(err);
        }.bind(this)
      );
  };

  handleEmailBilling = () => {
    if (
      this.emailRef.current.value != "" &&
      this.firstNameRef.current.value != "" &&
      this.billNumberRef.current.value != "" &&
      this.state.items != ""
    ) {
      let payload = {
        bill_id: this.state.billId,
        email: this.emailRef.current.value,
        name: this.firstNameRef.current.value,
        currency_id: this.state.selectedAsset.assetId,
        item_json: JSON.stringify(this.state.items),
        due_date: this.state.formatedDate,
        bill_number: this.billNumberRef.current.value,
        total_amount: this.state.totalAmount,
        merchant_id: parseInt(localStorage.getItem(SITENAMEALIAS + "_merchant_id")),
        network: this.state.network,
        // ── Processing fee field ──
        is_processing_fee_applied: this.state.processingFeeHandling === "customer" ? 1 : 0,
      };
      if (!this.state.isRecurringBillChecked) {
        payload["recurring_bill"] = 0;
      } else {
        payload["recurring_bill"] = 1;
      }
      if (
        this.address1Ref.current.value != "" &&
        this.stateRef.current.value != "" &&
        this.countryRef.current.value != "" &&
        this.cityRef.current.value != "" &&
        this.zipRef.current.value != ""
      ) {
        payload["address_l_1"] = this.address1Ref.current.value;
        payload["address_l_2"] = this.address2Ref.current.value;
        payload["state"] = this.stateRef.current.value;
        payload["country"] = this.countryRef.current.value;
        payload["city"] = this.cityRef.current.value;
        payload["zip"] = this.zipRef.current.value;
      } else {
        payload["address_l_1"] = "";
        payload["address_l_2"] = "";
        payload["state"] = "";
        payload["country"] = "";
        payload["city"] = "";
        payload["zip"] = "";
      }
      let items = this.state.items;
      let arr = [];
      for (let i = 0; i < items.length; i++) {
        let obj = {};
        obj["item_name"] = items[i].item;
        obj["item_price"] = formatAmount(items[i].price, 5);
        obj["item_quantity"] = items[i].qty;
        obj["fiat_price"] = items[i].fiat_price;
        arr.push(obj);
      }
      payload["item_json"] = JSON.stringify(arr);
      if (this.state.action == "add") {
        UpdateEmailBill(payload)
          .then(
            function (res) {
              this.setState({ showLoader: false });
              let response = res.data;
              let errorObj = response[response.length - 1];
              if (errorObj.error != "0") {
                showToast("error", errorObj.error_msg);
              } else {
                showToast("success", "Email billing updated successfully");
                this.renderEmailBillData(this.state.billId);
              }
            }.bind(this)
          )
          .catch(
            function (err) {
              this.setState({ showLoader: false });
              showHttpError(err);
            }.bind(this)
          );
      }
    } else {
      showToast("error", "Please provide all the fields");
    }
  };

  handleBack = () => {
    this.props.history.goBack();
  };

  addNewTableRow = () => {
    let rowLength = this.state.items.length;
    let obj = { row: rowLength + 1, item: "", qty: 0, price: formatAmount(0.0, 5) };
    let item = this.state.items;
    item.push(obj);
    this.setState({ items: item }, () => { this.calculateTotalAmount(); });
  };

  handleDeleteRow = (row) => {
    let array = this.state.items;
    let removeIndex = array.map((item) => item.row).indexOf(row);
    array.splice(removeIndex, 1);
    this.setState({ items: array }, () => { this.calculateTotalAmount(); });
  };

  handleEmail = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9._%+-]{1,30}@[a-zA-Z0-9-]{1,30}\.[a-zA-Z]{2,}$/;
    if (Regex.test(elm)) { this.setState({ emailAddr: false, verifyBtn: false }); }
    else { this.setState({ emailAddr: true, verifyBtn: true }); e.target.value = ""; }
  };

  handleCustName = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z-]{2,50}( [a-zA-Z-]{2,50})?$/;
    if (Regex.test(elm)) { this.setState({ custName: false, verifyBtn: false }); }
    else { this.setState({ custName: true, verifyBtn: true }); e.target.value = ""; }
  };

  handleAddr1 = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9\s\/\.,-]+$/;
    if (Regex.test(elm)) { this.setState({ addr1: false, verifyBtn: false }); }
    else { this.setState({ addr1: true, verifyBtn: true }); e.target.value = ""; }
  };

  handleAddr2 = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9\s\/\.,-]+$/;
    if (Regex.test(elm)) { this.setState({ addr2: false, verifyBtn: false }); }
    else { this.setState({ addr2: true, verifyBtn: true }); e.target.value = ""; }
  };

  handleCity = (e) => {
    let elm = e.target.value;
    let Regex = /^[A-Za-z ]+$/;
    if (Regex.test(elm)) { this.setState({ city: false, verifyBtn: false }); }
    else { this.setState({ city: true, verifyBtn: true }); e.target.value = ""; }
  };

  handleState = (e) => {
    let elm = e.target.value;
    let Regex = /^[A-Za-z ]+$/;
    if (Regex.test(elm)) { this.setState({ stateName: false, verifyBtn: false }); }
    else { this.setState({ stateName: true, verifyBtn: true }); e.target.value = ""; }
  };

  handleZipcode = () => {
    let elm = this.zipRef.current.value;
    let Regex = /^[a-zA-Z0-9 ]{1,15}$/;
    console.log(elm, Regex.test(elm));
    if (Regex.test(elm)) { this.setState({ zipcode: false, verifyBtn: false }); }
    else { this.setState({ zipcode: true, verifyBtn: true }); this.zipRef.current.value = ""; }
  };

  handleBillNo = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9 ]{1,15}$/;
    if (Regex.test(elm)) { this.setState({ billNumber: false, verifyBtn: false }); }
    else { this.setState({ billNumber: true, verifyBtn: true }); e.target.value = ""; }
  };

  handleItemName = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9 -]+$/;
    if (Regex.test(elm)) { this.setState({ itemName: false, verifyBtn: false }); }
    else { this.setState({ itemName: true, verifyBtn: true }); e.target.value = ""; }
  };

  handlePrice = (e) => {
    let elm = e.target.value;
    let Regex = /^[0-9]+(\.[0-9]+)?$/;
    if (Regex.test(elm)) { this.setState({ priceNum: false, verifyBtn: false }); }
    else { this.setState({ priceNum: true, verifyBtn: true }); e.target.value = ""; }
  };

  handleQuantity = (e) => {
    let elm = e.target.value;
    let Regex = /^[0-9]+(\.[0-9]+)?$/;
    if (Regex.test(elm)) { this.setState({ quantityNum: false, verifyBtn: false }); }
    else { this.setState({ quantityNum: true, verifyBtn: true }); e.target.value = ""; }
  };

  handleSetValue = (row, field, e) => {
    let currency = this.state.selectedAsset.assetCode;
    let items = this.state.items;
    let data = e.target.value;
    if (field == "item" || field == "qty") {
      for (let i = 0; i < items.length; i++) {
        if (row == items[i].row) {
          if (field == "item") items[i].item = data;
          else if (field == "qty") items[i].qty = data;
        }
      }
      this.setState({ items: items }, () => { this.calculateTotalAmount(); });
    } else {
      this.setState({ showLoader: true });
      GetMarketPrice(currency)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data;
            let price = response.price;
            let convertedPrice = parseFloat(data) / parseFloat(price);
            for (let i = 0; i < items.length; i++) {
              if (row == items[i].row) items[i].price = convertedPrice.toFixed(6);
            }
            this.setState({ items: items }, () => { this.calculateTotalAmount(); });
          }.bind(this)
        )
        .catch(function (err) { this.setState({ showLoader: false }); }.bind(this));
    }
  };

  handleSelectedCurrency = (e) => {
    let code = e.target.value;
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: code,
    };
    this.setState({ showLoader: true });
    GetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (
              response.accept_overpayments != "" && response.accept_overpayments != null && response.accept_overpayments != "no" &&
              response.accept_underpayments != "" && response.accept_underpayments != null && response.accept_underpayments != "no"
            ) {
              const newAsset = handleDynamicCurrencyDetiails(this.state.assets, code);
              this.setState(
                {
                  selectedAsset: newAsset,
                  networkArray: newAsset.network,
                  network: newAsset.network[0],
                },
                () => {
                  // ── Refresh txn charge for newly selected currency ──
                  this.fetchTxnCharge(newAsset.assetCode);
                }
              );
            } else {
              showConfirm("Set your underpayment or overpayment tolerance limits", "Go to Merchant Settings > Automatic Exception Handling", "error", () => {
                localStorage.setItem(SITENAMEALIAS + "_need_tolerance_setting", "true");
                localStorage.setItem(SITENAMEALIAS + "_need_tolerance_setting_for_currency", code);
                this.props.history.push("/settings");
              });
            }
          }
        }.bind(this)
      )
      .catch(function (err) { this.setState({ showLoader: false }); showHttpError(err); }.bind(this));
  };

  handleNetworkChange = (e) => {
    this.setState({ network: e.target.value }, () => {
      if (this.state.selectedAsset.assetCode) {
        this.getMarketPriceOnLoad(this.state.selectedAsset.assetCode);
      }
    });
  };

  getMarketPriceOnLoad = async (currency) => {
    this.setState({ showLoader: true });
    GetMarketPrice(currency)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let price = response.price;
          this.setState({ marketPriceOnRender: price }, () => {
            let items = this.state.items;
            for (let i = 0; i < items.length; i++) {
              let item = items[i];
              let usdPrice = parseFloat(item.price) * parseFloat(this.state.marketPriceOnRender);
              document.getElementById("usdPriceFor" + item.row).value = usdPrice.toFixed(2);
            }
          });
        }.bind(this)
      )
      .catch(function (err) { this.setState({ showLoader: false }); }.bind(this));
  };

  handleDeleteBill = () => {
    showConfirm("Delete", "Are you sure want to delete?", "warning", () => {
      let payload = {
        bill_id: this.state.billId,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };
      this.setState({ showLoader: true });
      DeleteEmailBill(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              showToast("success", "Email bill deleted successfully");
              this.props.history.push("/email-billing");
            }
          }.bind(this)
        )
        .catch(function (err) { this.setState({ showLoader: false }); showHttpError(err); }.bind(this));
    });
  };

  handleRenderAssets = () => {
    let payload = { merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id") };
    this.setState({ showLoader: true });
    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              let coinBalance = response.coin_balance;
              let arr = [];
              if (coinBalance != undefined) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (coinBalance[i].currency_code != "USD") {
                    arr.push({
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    });
                  }
                }
              }
              const currencyOrder = ['USDC', 'USDT', 'XRP', 'DOGE', 'HCX', 'ETH', 'BTC', 'LTC', 'BCH'];
              arr.sort((a, b) => {
                const idxA = currencyOrder.indexOf(a.assetCode);
                const idxB = currencyOrder.indexOf(b.assetCode);
                return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
              });
              this.setState({ assets: arr }, () => {
                localStorage.setItem(SITENAMEALIAS + "_assets", JSON.stringify(this.state.assets));
                // renderEmailBillData will call fetchTxnCharge after restoring the currency
                this.renderEmailBillData(this.state.billId);
              });
            }
          }
        }.bind(this)
      )
      .catch(function (err) { this.setState({ showLoader: false }); showHttpError(err); }.bind(this));
  };

  componentDidMount() {
    const match = matchPath(this.props.history.location.pathname, {
      path: "/edit-email-bill/:param1",
      exact: true,
      strict: false,
    });
    this.setState({ billId: match.params.param1 }, () => {
      this.handleRenderAssets();
    });
  }

  renderAddressFields() {
    return (
      <div style={{ gridColumn: "1 / -1" }}>
        <div style={{ ...styles.formGrid, marginTop: "8px" }}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Address Line 1 *</label>
            <input type="text" style={styles.input} ref={this.address1Ref} defaultValue={this.state.addr_1} onBlur={this.handleAddr1} placeholder="Enter address line 1" />
            {this.state.addr1 && <span style={styles.errorText}>Please insert valid address</span>}
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Address Line 2</label>
            <input type="text" style={styles.input} ref={this.address2Ref} defaultValue={this.state.addr_2} onBlur={this.handleAddr2} placeholder="Enter address line 2" />
            {this.state.addr2 && <span style={styles.errorText}>Please insert valid address</span>}
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>City *</label>
            <input type="text" style={styles.input} ref={this.cityRef} defaultValue={this.state.cityName} onBlur={this.handleCity} placeholder="Enter city" />
            {this.state.city && <span style={styles.errorText}>Please insert valid city name</span>}
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>State *</label>
            <input type="text" style={styles.input} ref={this.stateRef} defaultValue={this.state.statename} onBlur={this.handleState} placeholder="Enter state" />
            {this.state.stateName && <span style={styles.errorText}>Please insert valid state name</span>}
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Country *</label>
            <select style={styles.select} ref={this.countryRef} defaultValue={this.state.countryName}>
              <option value="">Select Country</option>
              {COUNTRYLIST.map((iter, i) => (
                <option key={iter + "_" + i} value={iter}>{iter}</option>
              ))}
            </select>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Zip Code *</label>
            <input type="text" style={styles.input} ref={this.zipRef} onChange={this.handleZipcode} placeholder="Enter zip code" />
            {this.state.zipcode && <span style={styles.errorText}>Please insert valid zipcode</span>}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { processingFeeHandling, txnCharge } = this.state;

    const feeOptionStyle = (val) => ({
      flex: 1,
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      padding: "14px 16px",
      borderRadius: "12px",
      border: processingFeeHandling === val
        ? "1.5px solid var(--btn-color)"
        : "1.5px solid var(--body-color-less2)",
      background: processingFeeHandling === val
        ? "color-mix(in srgb, var(--btn-color), transparent 93%)"
        : "var(--body-color)",
      cursor: "pointer",
      userSelect: "none",
      transition: "all 0.15s ease",
    });

    const radioDotStyle = (val) => ({
      width: "16px",
      height: "16px",
      borderRadius: "50%",
      border: processingFeeHandling === val
        ? "5px solid var(--btn-color)"
        : "2px solid color-mix(in srgb, var(--text-color), transparent 55%)",
      background: "var(--body-color)",
      flexShrink: 0,
      marginTop: "2px",
      transition: "all 0.15s ease",
    });

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={styles.pageWrapper}>
              {/* Back + Title + Actions */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "28px", flexWrap: "wrap", gap: "16px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                  <div style={styles.backBtn} onClick={this.handleBack}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                  </div>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <h2 style={styles.pageTitle}>Edit Email Bill</h2>
                      {this.state.status && (
                        <span style={styles.statusBadge(this.state.status)}>
                          {styles.statusText(this.state.status)}
                        </span>
                      )}
                    </div>
                    <div style={styles.pageSubtitle}>
                      Update bill details, send or delete this email bill
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button type="button" style={styles.btnDanger} onClick={this.handleDeleteBill}>
                    <i className="mdi mdi-delete-outline" /> Delete
                  </button>
                  <button type="button" style={styles.btnSend} onClick={this.handleSendEmailBill}>
                    <i className="mdi mdi-send" /> Send Bill
                  </button>
                </div>
              </div>

              {/* Buyer Information Card */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div style={{ ...styles.cardHeaderIcon, background: "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 15%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))", color: "var(--btn-color)" }}>
                    <i className="mdi mdi-account-outline" />
                  </div>
                  <h4 style={styles.cardHeaderTitle}>Buyer Information</h4>
                </div>
                <div style={styles.cardBody}>
                  <div style={styles.formGrid}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Email Address *</label>
                      <input type="email" style={styles.input} ref={this.emailRef} defaultValue={this.state.email} onBlur={this.handleEmail} placeholder="Enter customer email" />
                      {this.state.emailAddr && <span style={styles.errorText}>Please insert valid email address</span>}
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Customer Name *</label>
                      <input type="text" style={styles.input} ref={this.firstNameRef} defaultValue={this.state.customerName} onBlur={this.handleCustName} placeholder="Enter customer name" />
                      {this.state.custName && <span style={styles.errorText}>Please insert valid name</span>}
                    </div>
                    {this.renderAddressFields()}
                  </div>
                </div>
              </div>

              {/* Bill Details Card */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div style={{ ...styles.cardHeaderIcon, background: "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 15%, transparent), color-mix(in srgb, #8b5cf6 5%, transparent))", color: "#8b5cf6" }}>
                    <i className="mdi mdi-file-document-outline" />
                  </div>
                  <h4 style={styles.cardHeaderTitle}>Bill Details</h4>
                </div>
                <div style={styles.cardBody}>
                  <div style={styles.formGrid}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Currency</label>
                      <select style={styles.select} value={this.state.selectedAsset.assetId} onChange={(e) => this.handleSelectedCurrency(e)}>
                        {this.state.assets.map((item) => (
                          <option key={item.assetId} value={item.assetId}>{item.assetCode} - {item.assetName}</option>
                        ))}
                      </select>
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Network</label>
                      {this.state.networkArray.length > 1 ? (
                        <select style={styles.select} value={this.state.network} onChange={(e) => this.handleNetworkChange(e)}>
                          {this.state.networkArray.map((network) => (
                            <option key={network} value={network}>{network}</option>
                          ))}
                        </select>
                      ) : (
                        <input
                          type="text"
                          style={styles.select}
                          value={this.state.networkArray[0] || ""}
                          disabled
                        />
                      )}
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Due Date</label>
                      <DatePicker
                        selected={this.state.selectedDate}
                        ref={this.dateRef}
                        defaultValue={this.state.dateVal}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Please choose a date"
                        className="form-control w-100"
                        onChange={(date) => { this.handleDateChange(date); }}
                        wrapperClassName="w-100"
                        customInput={<input type="text" style={styles.input} />}
                      />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Bill Number *</label>
                      <input type="text" style={styles.input} ref={this.billNumberRef} defaultValue={this.state.billnumber} onBlur={this.handleBillNo} placeholder="Enter bill number" />
                      {this.state.billNumber && <span style={styles.errorText}>Please insert valid bill number</span>}
                    </div>
                    <div style={styles.checkboxRow}>
                      <input type="checkbox" style={styles.checkbox} id="recurring_bill_edit" checked={this.state.isRecurringBillChecked} onChange={this.handleRecurringBillChange} />
                      <label htmlFor="recurring_bill_edit" style={styles.checkboxLabel}>This is a recurring bill</label>
                    </div>
                  </div>
                </div>
              </div>

              {/* ══ Processing Fee Handling Card ══ */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div style={{
                    ...styles.cardHeaderIcon,
                    background: "linear-gradient(135deg, color-mix(in srgb, #14b8a6 15%, transparent), color-mix(in srgb, #14b8a6 5%, transparent))",
                    color: "#14b8a6",
                  }}>
                    <i className="fa fa-percent" />
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <h4 style={styles.cardHeaderTitle}>Processing Fee Handling</h4>
                    {txnCharge != null && (
                      <span style={{ fontSize: "11px", fontWeight: "700", color: "#14b8a6", background: "color-mix(in srgb, #14b8a6, transparent 88%)", borderRadius: "6px", padding: "2px 8px" }}>
                        {txnCharge}
                      </span>
                    )}
                  </div>
                </div>
                <div style={styles.cardBody}>
                  <p style={{ fontSize: "13px", color: "var(--text-color)", opacity: 0.6, margin: "0 0 16px" }}>
                    Choose how transaction fees are applied for this bill.
                  </p>
                  <div style={{ display: "flex", gap: "14px" }}>
                    <div style={feeOptionStyle("customer")} onClick={() => this.setState({ processingFeeHandling: "customer" })}>
                      <div style={radioDotStyle("customer")} />
                      <div>
                        <div style={{ fontSize: "13px", fontWeight: "600", color: "var(--text-color)", marginBottom: "3px" }}>
                          Customer pays the processing fee
                        </div>
                        <div style={{ fontSize: "12px", color: "var(--text-color)", opacity: 0.5 }}>
                          {txnCharge != null ? `${txnCharge} ${this.state.selectedAsset.assetCode} will be added to the checkout total.` : "The fee will be added to the checkout total."}
                        </div>
                      </div>
                    </div>
                    <div style={feeOptionStyle("merchant")} onClick={() => this.setState({ processingFeeHandling: "merchant" })}>
                      <div style={radioDotStyle("merchant")} />
                      <div>
                        <div style={{ fontSize: "13px", fontWeight: "600", color: "var(--text-color)", marginBottom: "3px" }}>
                          Merchant absorbs the processing fee
                        </div>
                        <div style={{ fontSize: "12px", color: "var(--text-color)", opacity: 0.5 }}>
                          {txnCharge != null ? `${txnCharge} ${this.state.selectedAsset.assetCode} will be deducted from your payout.` : "The fee will be deducted from your payout."}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ══ End Processing Fee Handling Card ══ */}

              {/* Line Items Card */}
              <div style={styles.card}>
                <div style={{ ...styles.cardHeader, justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{ ...styles.cardHeaderIcon, background: "linear-gradient(135deg, color-mix(in srgb, #10b981 15%, transparent), color-mix(in srgb, #10b981 5%, transparent))", color: "#10b981" }}>
                      <i className="mdi mdi-cart-outline" />
                    </div>
                    <h4 style={styles.cardHeaderTitle}>Line Items</h4>
                  </div>
                  <button type="button" style={styles.addItemBtn} onClick={() => this.addNewTableRow()}>
                    <i className="mdi mdi-plus" /> Add Item
                  </button>
                </div>

                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={styles.th}>Item</th>
                        <th style={styles.th}>Price ($)</th>
                        <th style={{ ...styles.th, position: "relative" }}>
                          Crypto Price ({this.state.selectedAsset.assetCode})
                          <span className="tooltip-container" style={styles.infoTip}>
                            <i className="fa fa-info-circle info-icon" style={{ fontSize: "12px", opacity: 0.5 }}></i>
                            <span className="tooltip-text" style={{ textAlign: "justify" }}>
                              The amount in crypto shown here is indicative. When the payment is actually made, the system will check the market price of crypto at that time and deduct the equivalent amount.
                            </span>
                          </span>
                        </th>
                        <th style={styles.th}>Quantity</th>
                        <th style={{ ...styles.th, textAlign: "right" }}>Amount</th>
                        <th style={{ ...styles.th, textAlign: "center", width: "60px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.items.map((item) => (
                        <tr key={item.row}>
                          <td style={styles.td}>
                            <input type="text" style={styles.tableInput} onChange={(e) => { this.handleSetValue(item.row, "item", e); }} onBlur={this.handleItemName} value={item.item} placeholder="Item name" />
                            {this.state.itemName && <span style={styles.errorText}>Please insert valid item name</span>}
                          </td>
                          <td style={styles.td}>
                            <input type="number" id={"usdPriceFor" + item.row} style={styles.tableInput} onKeyUp={(e) => { this.handleSetValue(item.row, "price", e); }} onBlur={this.handlePrice} value={item.fiat_price} placeholder="0.00" />
                            {this.state.priceNum && <span style={styles.errorText}>Please insert valid price</span>}
                          </td>
                          <td style={styles.td}>
                            <input type="number" style={{ ...styles.tableInput, opacity: 0.6, cursor: "not-allowed" }} value={item.price} disabled />
                          </td>
                          <td style={styles.td}>
                            <input
                              type="text"
                              style={styles.tableInput}
                              onChange={(e) => {
                                if (_isOnlyNumber(e.target.value)) {
                                  this.handleSetValue(item.row, "qty", e);
                                }
                              }}
                              onBlur={this.handleQuantity}
                              value={item.qty}
                              placeholder="0"
                            />
                            {this.state.quantityNum && <span style={styles.errorText}>Please insert valid quantity</span>}
                          </td>
                          <td style={{ ...styles.td, textAlign: "right" }}>
                            <span style={{ fontWeight: "600", fontFamily: "'SF Mono', 'Fira Code', monospace", fontSize: "13px" }}>
                              <span style={{ opacity: 0.5, marginRight: "4px" }}>{this.state.selectedAsset.assetCode}</span>
                              {item.price != "" && item.qty != ""
                                ? formatAmount(parseFloat(item.price) * parseFloat(item.qty), 5)
                                : formatAmount(0, 5)}
                            </span>
                          </td>
                          <td style={{ ...styles.td, textAlign: "center" }}>
                            <button type="button" style={styles.deleteRowBtn} onClick={() => { showConfirm("Delete", "Are you sure you want to delete this item?", "warning", () => this.handleDeleteRow(item.row)); }}>
                              <i className="mdi mdi-delete-forever" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Total */}
                <div style={styles.totalRow}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={styles.totalLabel}>Total</span>
                    <span className="tooltip-container" style={styles.infoTip}>
                      <i className="fa fa-info-circle info-icon" style={{ fontSize: "12px", opacity: 0.4 }}></i>
                      <span className="tooltip-text">
                        The amount in crypto shown here is indicative. When the payment is actually made, the system will check the market price of crypto at that time and deduct the equivalent amount.
                      </span>
                    </span>
                  </div>
                  <span style={styles.totalAmount}>
                    {this.state.selectedAsset != null && this.state.selectedAsset.assetCode}{" "}
                    {this.state.totalAmount}
                  </span>
                </div>
              </div>

              {/* Submit */}
              <div style={{ display: "flex", justifyContent: "flex-end", padding: "0 4px", marginTop: "8px" }}>
                <button
                  type="button"
                  style={this.state.verifyBtn ? styles.btnPrimaryDisabled : styles.btnPrimary}
                  onClick={() => { this.handleEmailBilling(); }}
                  disabled={this.state.verifyBtn}
                >
                  Save Changes
                </button>
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default withRouter(EditEmailbilling);